<template>
  <div class="PsPatientWeeklyTracking">

    <el-table
      :data="tableRows"
      border
      :header-cell-style="{ background: '#409EFF', color: '#fff', textAlign: 'center' }"
      
    >
      <el-table-column
        prop="weekLabel"
        label="SEMANA"
        width="100"
        align="center"
      >
        <template slot-scope="scope">
          <div style="font-weight: 500; font-size: 11px;">{{ scope.row.weekLabel }}</div>
        </template>
      </el-table-column>

      <el-table-column
        v-for="column in columns"
        :key="column.id"
        :label="column.title"
        align="center"
      >
        <template slot="header">
          <div style="line-height: 1.2">
            <div style="font-size: 12px; font-weight: 600">{{ column.title }}</div>
            <div v-if="column.subtitle" style="font-size: 10px; opacity: 0.85; margin-top: 2px">
              {{ column.subtitle }}
            </div>
          </div>
        </template>
        <template slot-scope="scope">
          <div
            class="cell-content"
            :class="getCellColorClass(scope.row.weekLabel, column.id)"
            @dblclick="handleCellDoubleClick(scope.row.weekLabel, column.id)"
            :title="getCellText(scope.row.weekLabel, column.id) || 'Doble click para editar nota'"
          >
            <div class="cell-text">
              {{ getCellText(scope.row.weekLabel, column.id) }}
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="Nota"
      :visible.sync="dialogWeeklyTrackingCell"
      width="500px"
      @close="handleDialogClose"
    >
      <el-form label-position="top">
        <el-form-item>
          <el-radio-group 
            :value="weeklyTrackingCell.color" 
            @input="changeProperty($event, 'color')"
            size="medium"
          >
            <el-radio-button label="verde">Bien</el-radio-button>
            <el-radio-button label="amarillo">Regular</el-radio-button>
            <el-radio-button label="rojo">Mal</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input
            type="textarea"
            :rows="4"
            placeholder="Escribe una nota (máximo 250 caracteres)"
            :value="weeklyTrackingCell.text"
            @input="changeProperty($event, 'text')"
            maxlength="250"
            show-word-limit
          >
          </el-input>
        </el-form-item>        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose" :disabled="loading">Cancelar</el-button>
        <el-button type="primary" @click="handleSaveCell" :disabled="loading" :loading="loading">Guardar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'PsPatientWeeklyTracking',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('patients', [
      'patient',
      'weeklyTrackingConfig',
      'dialogWeeklyTrackingCell',
      'weeklyTrackingCell',
      'weeklyTrackingCells',
      'newWeeklyTrackingCell'
    ]),
    ...mapState('weeklyTracking', [
      'weeklyTrackings'
    ]),
    columns() {
      return this.weeklyTrackings
    },
    visibleWeeks() {
      return 5
    },
    weekLabels() {
      const weeks = []
      const today = new Date()
      
      // Usar componentes de fecha local para evitar problemas de zona horaria
      const todayYear = today.getFullYear()
      const todayMonth = today.getMonth()
      const todayDate = today.getDate()
      
      for (let i = 0; i < this.visibleWeeks; i++) {
        // Crear fecha usando componentes locales (sin hora)
        const date = new Date(todayYear, todayMonth, todayDate - (i * 7))
        
        const dayOfWeek = date.getDay()
        const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1
        
        // Calcular el lunes de esa semana
        const monday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - daysToMonday)
        
        const day = String(monday.getDate()).padStart(2, '0')
        const monthNames = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
        const month = monthNames[monday.getMonth()]
        
        weeks.push(`${day}-${month}`)
      }
      
      return weeks
    },
    tableRows() {
      return this.weekLabels.map(weekLabel => ({ weekLabel }))
    },
    cellsMap() {
      const map = {}
      this.weeklyTrackingCells.forEach(cell => {
        const key = `${cell.weekLabel}_${cell.weeklyTrackingId}`
        map[key] = cell
      })
      return map
    }
  },
  methods: {
    ...mapMutations('patients', [
      'PATIENTS_DIALOG_WEEKLY_TRACKING_CELL',
      'PATIENTS_WEEKLY_TRACKING_CELL',
      'PATIENTS_WEEKLY_TRACKING_CELL_PROP',
      'PATIENTS_WEEKLY_TRACKING_CELLS'
    ]),
    ...mapActions('patients', [
      'getWeeklyTrackingConfigHTTP',
      'getWeeklyTrackingCellsHTTP',
      'saveWeeklyTrackingCell',
    ]),
    ...mapActions('weeklyTracking', [
      'getWeeklyTrackingsHTTP',
    ]),
    changeProperty(value, property) {
      this.PATIENTS_WEEKLY_TRACKING_CELL_PROP({ property, value });
    },
    getCellKey(weekLabel, columnId) {
      return `${weekLabel}_${columnId}`
    },
    getCell(weekLabel, columnId) {
      const key = this.getCellKey(weekLabel, columnId)
      return this.cellsMap[key] || null
    },
    getCellText(weekLabel, columnId) {
      const cell = this.getCell(weekLabel, columnId)
      return cell ? cell.text : ''
    },
    getCellColor(weekLabel, columnId) {
      const cell = this.getCell(weekLabel, columnId)
      return cell ? cell.color : 'ninguno'
    },
    getCellColorClass(weekLabel, columnId) {
      const color = this.getCellColor(weekLabel, columnId)
      return color !== 'ninguno' ? `cell-${color}` : ''
    },
    handleCellDoubleClick(weekLabel, columnId) {
      const cell = this.getCell(weekLabel, columnId)
      
      if (cell) {
        this.PATIENTS_WEEKLY_TRACKING_CELL(JSON.parse(JSON.stringify(cell)))
      } else {
        this.PATIENTS_WEEKLY_TRACKING_CELL({
          ...this.newWeeklyTrackingCell,
          patientId: this.$route.params["patientId"],
          weekLabel: weekLabel,
          weeklyTrackingId: columnId,          
        })
      }
      
      this.PATIENTS_DIALOG_WEEKLY_TRACKING_CELL(true)
    },
    handleDialogClose() {
      this.PATIENTS_DIALOG_WEEKLY_TRACKING_CELL(false)
    },
    async handleSaveCell() {
      
      try {
        this.loading = true
        await this.saveWeeklyTrackingCell()
        await this.getWeeklyTrackingCellsHTTP(this.$route.params["patientId"])
  
        this.PATIENTS_DIALOG_WEEKLY_TRACKING_CELL(false)
        this.PATIENTS_WEEKLY_TRACKING_CELL({})
        this.$message({
          message: 'Celda guardada correctamente',
          type: 'success'
        })
      } catch (err) {
        console.log(err);
        this.$message({
          message: err.response.data.err.details,
          type: "error",
        });
      } finally {
        this.loading = false
      }
      
    }
  },
  async beforeMount() {
    await this.getWeeklyTrackingsHTTP()
    await this.getWeeklyTrackingCellsHTTP(this.$route.params["patientId"])
  }
}
</script>

<style scoped>
.PsPatientWeeklyTracking {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

.PsPatientWeeklyTracking >>> .el-table {
  table-layout: fixed;
}

.PsPatientWeeklyTracking >>> .el-table__body-wrapper .el-table__body td {
  padding: 0 !important;
  height: 80px !important;
  vertical-align: top !important;
  overflow: hidden;
}

.PsPatientWeeklyTracking >>> .el-table__header-wrapper .el-table__header th {
  padding: 8px 4px !important;
}

.PsPatientWeeklyTracking >>> .el-table__body-wrapper .el-table__body td .cell {
  padding: 0 !important;
  height: 100% !important;
}

.legend {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  font-size: 13px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.color-dot.ninguno {
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
}

.color-dot.verde {
  background-color: #d4edda;
}

.color-dot.amarillo {
  background-color: #fff3cd;
}

.color-dot.rojo {
  background-color: #f8d7da;
}

.cell-content {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
}

.cell-text {
  font-size: 11px;
  line-height: 1.3;
  color: #606266;
  text-align: left;
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.cell-verde {
  background-color: #d4edda !important;
}

.cell-amarillo {
  background-color: #fff3cd !important;
}

.cell-rojo {
  background-color: #f8d7da !important;
}

.el-dialog__body {
  padding-top: 0;
}

.el-radio-group >>> .el-radio-button .el-radio-button__inner {
  background-color: #e0e0e0;
  border-color: #ababab;
  color: #303133;
  transition: all 0.3s ease;
}


.el-radio-group >>> .el-radio-button:nth-child(1).is-active .el-radio-button__inner,
.el-radio-group >>> .el-radio-button:nth-child(1):hover .el-radio-button__inner {
  background-color: #b8e2c1;
  color: #0d3d18;
}

.el-radio-group >>> .el-radio-button:nth-child(2).is-active .el-radio-button__inner,
.el-radio-group >>> .el-radio-button:nth-child(2):hover .el-radio-button__inner {
  background-color: #ffe8a1;
  color: #664d03;
}

.el-radio-group >>> .el-radio-button:nth-child(3).is-active .el-radio-button__inner,
.el-radio-group >>> .el-radio-button:nth-child(3):hover .el-radio-button__inner {
  background-color: #f5c2c7;
  color: #58151c;
}
</style>
